<div class="pollContainer">
  <!--tooltip current year-->
  @if (isShowingPopUp) {
    <div class="popup" [style.left]="positionTooltip"><div class="verticalLinePopUp"></div>{{pollControl?.value}}</div>
  }

  <!--slider-->
  <input type="range" name="sliderCutom"
    [attr.min]="minValue"
    [attr.max]="assignatedCount"
    [formControl]="pollControl"
    (input)="sliderMove($event)"
    (click)="sliderClick($event)"
    (touchend)="sliderClick($event)"
    (mousedown)="showPopUp()"
    (mouseup)="hidePopUp()"
    data-e2e="pool-slider">
    <div class="line" [style.width]="positionTooltip"></div>
    @if (valPol==='100%') {
      <div class="endLine"></div>
    }
    <h1 class="pourcent" [style.left]="positionTooltip">{{valPol}}</h1>

    <div class="poll-legend">
      <p>{{'poll.legend.not_ok' | translate}}</p>
      <p>{{'poll.legend.ok' | translate}}</p>
    </div>
  </div>
